import { Video, joinRequest, room } from "../libs/roomnew";

export default class KinoLimits{
    constructor(limit,reached){
        this.participants_limit=limit;
        this.participant_limit_reached=reached;
    }
    isParticipantLimitReached(){
        return this.participant_limit_reached;
    }
    setParticipantsLimit(limit){
        this.participants_limit=limit;
    };
    setParticipantLimitReached(reached){
        this.participant_limit_reached=reached;
    };

    showParticipantLimitModal(fromRequest=false){
        if(fromRequest){
          $("#participants-limit-modal").find(".plimit-joining-information").css("display","flex");
        }else{
          $("#participants-limit-modal").find(".plimit-joining-information").css("display","none");
        }
        this.setMessage('',false); //message container on participant limit modal when request has been sent
        $("#participants-limit-modal").modal('show');
    };
    hideParticipantsLimitModal(){
        if($("#participants-limit-modal").hasClass('show')){
           $("#participants-limit-modal").modal('hide');         
        }
    };
    isModalShown(){
        return $("#participants-limit-modal").hasClass('show');
    };
    setMessage(message,error=false,loading=false){
        $("#plimit-joining-message").html(message);
        if(error){
            $("#plimit-joining-message").addClass('error-red');
            $("#participants-limit-loading").css("display","none")
        }else{
            $("#plimit-joining-message").removeClass('error-red');
            if(loading){
                $("#participants-limit-loading").css("display","block")
            }else{
                $("#participants-limit-loading").css("display","none")
            }
        }
    };

    onUsersCountChanged(addPretendParticipants=0,showNotification=true){
       let participants=Object.keys(Video.videos).length;
       participants+=1; //add also me
       participants+=addPretendParticipants;
       if(participants >= this.participants_limit && this.participants_limit > -1){
           if(!this.isParticipantLimitReached()){
               //maybe show a notification saying that participant limit reached
               this.onParticipantLimitReachedChanged(false,true,showNotification);
           }
            this.setParticipantLimitReached(true);
       }else{
            if(this.isParticipantLimitReached()){
                //maybe show a notification
                this.onParticipantLimitReachedChanged(true,false,showNotification);
            }
            this.setParticipantLimitReached(false);
        }
    };
    isModerator(){
        return ROLE == "moderator" || HOST==1;
    };

    onParticipantLimitReachedChanged(oldValue,newValue,shownotification=true){
        joinRequest.makeRequestsEnabled(!newValue);
        if(shownotification && newValue && this.isModerator() && $("#notificationsBanner").find(`.participants_limit_message-notification-${room.myUserId()}`).length==0){
            Video.showNotification('<i class="far fa fa-users fa-lg" style="color:#fff"></i>',"Participants limit has been reached on this kino",'participants_limit_message',room.myUserId())
        }
    };
};